import React from 'react';
import classnames from 'classnames';
import './collapsible-sub-group-listing.scss';
import UpArrow from './library-components/Icons/UpArrow';
import DownArrow from './library-components/Icons/DownArrow';
import { Table, Description, Button, ButtonGroup, ProgressBar } from './library-components';
import currencyUtils from '../helpers/currencyUtils';

const Collapsible = ({ collapsible, toggle, active, children }) => {
  const cardClass = classnames('accordion-item accordion-item--white', { 'accordion-item--collapsed accordion__item--min_height_80': collapsible, 'accordion-item--expand': active });
  const iconClass = classnames('accordion-item--collapse-icon');

  return (
    <div className={cardClass}>
      <div className='accordion-item__header accordion-item-header' onClick={toggle}>
        <div className='accordion-item-header__left'>
          <h3 className='accordion-item-header__title' >{children.name} ({children.subscription_plans.length})</h3>
          <ul className=' accordion-item-header__description subscription-group-details'>
            <li>{children.subscription_type.toUpperCase()}</li>
            <li>{children.public ? 'Public' : 'Private'}</li>
          </ul>
        </div>
        <div className='accordion-item-header__right'>
          {children.subscription_type === 'campaign' &&
            <ProgressBar progressPercent={`${Math.round(children.collected_amount_percentage)}%`} progressText='funded' />
          }
          <div className='custom-align'>
            <Button url={`/subscription_groups/${children.id}`} > Edit </Button>
          </div>
          { collapsible && <span className={iconClass}>{active ? <UpArrow /> : <DownArrow />}</span> }
        </div>
      </div>
      <div className='accordion-item__body'>
        <Description>{children.description}</Description>

        {active && children.subscription_plans.length > 0 &&
        <Table header={['Id', 'Name', 'Duration', 'Price', 'Visibility']} className='table-default--5cols'>
          {children.subscription_plans.map((plan, index) =>
            <a href={`/subscription_groups/${children.id}/subscription_plans/${plan.id}`} key={index} className='table-default__row'>
              <div className='table-default__cell'> {plan.id} </div>
              <div className='table-default__cell'> {plan.title} </div>
              <div className='table-default__cell'> {plan.duration_length} {plan.duration_unit} </div>
              <div className='table-default__cell'> {plan.price_currency} {currencyUtils.convertToCurrencyUnits(plan.price_cents)} </div>
              <div className='table-default__cell'> {children.public ? 'Public' : 'Private'} </div>
            </a>
          )}
        </Table>}

      </div>
      {active && <div className='accordion-item__footer'>
        <ButtonGroup>
          <Button url={`/analytics_subscriptions?subscription_group_id=${children.id}`} >Subscriptions</Button>
          <Button url={`/subscription_groups/${children.id}/subscription_plans/new`} primary> Add New Plan </Button>
        </ButtonGroup>
      </div>}
    </div>
  );
};

export default Collapsible;
